export default __webpack_public_path__ + "static/media/hardAcclerate.a794fff0.png";